// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const TransactionImportList = () => import('@/modules/transactions/views/TransactionImportList')


var routes = [
    {
        path: '/transaction/import-list',
        redirect: '/transaction/import-list',
        name: 'TransactionImport',
        component: DefaultContainer,
        children: [
            {
				path: '/transaction/import-list',
                name: 'TransactionImportList',
                component: TransactionImportList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
        ]
    },
];


export default routes;
